import { Box, Typography, useTheme } from '@mui/material';
import { ReadonlyCoverageValue as ReadonlyCoverageValueSchema } from '@/schemas/sceneDataSchema';
import { useCoverageAttribute } from '@/hooks/use-quote';

export const ReadonlyCoverageValueFormElement = ({ component }: { component: ReadonlyCoverageValueSchema }) => {
  const theme = useTheme();
  const { options, findSelectedIndex } = useCoverageAttribute({
    symbol: component.symbol,
    scope: component.scope,
    kind: component.kind,
  });

  const selectedIndex = findSelectedIndex();
  const selectedOption = selectedIndex >= 0 ? options[selectedIndex] : null;

  if (!selectedOption) return null;

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        padding: 2,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography
        variant='body2'
        color='text.secondary'
        sx={{ letterSpacing: '.08em', textTransform: 'uppercase' }}
      >
        {component.label}
      </Typography>
      <Typography
        variant='body1'
        fontWeight='medium'
      >
        {selectedOption.label}
      </Typography>
    </Box>
  );
};
